// /src/components/ServiciosSII.js
import { useNavigate } from 'react-router-dom';
import '../styles/pages/ServiciosSII.css';


const ServiciosSII = ({ id_company }) => {
    const navigate = useNavigate();

    // Opciones de servicios disponibles
    const servicios = [
        { nombre: "Declaración de IVA", ruta: "/declaracion-iva" },
        { nombre: "Declaraciones Juradas", ruta: "/declaraciones-juradas" },
        { nombre: "Declaración de Renta", ruta: "/declaracion-renta" }
    ];

    const handleServicioClick = (ruta) => {
        navigate(ruta, { state: { id_company } });
    };

    return (
        <div className="servicios-page">
            <h1>Servicios SII</h1>
            <div className="servicios-grid">
                {servicios.map((servicio, index) => (
                    <div
                    key={index}
                    className="service-box"
                    onClick={() => handleServicioClick(servicio.ruta)}>
                    {servicio.nombre}
                </div>
                ))}
            </div>
        </div>
    );
};

export default ServiciosSII;
